import { Link } from "react-router-dom";
import { navLinks, siteInfo, socialLinks } from "@/mocks/site";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="border-t border-background-200/60 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-foreground-950">
                <i className="ri-movie-2-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-50">
                黄色<span className="text-primary-400">大片</span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-400">{siteInfo.description}</p>
            <div className="mt-5 flex items-center gap-2">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-200/70 text-foreground-300 transition-colors hover:bg-primary-500 hover:text-foreground-950"
                >
                  <i className={`${social.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-label text-sm uppercase tracking-widest text-foreground-500">
              <a href="#footer-nav" className="hover:text-primary-400">站点导航</a>
            </h4>
            <ul id="footer-nav" className="mt-4 space-y-3">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-300 transition-colors hover:text-primary-400">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm uppercase tracking-widest text-foreground-500">
              <a href="#footer-cat" className="hover:text-primary-400">电影分类</a>
            </h4>
            <ul id="footer-cat" className="mt-4 grid grid-cols-2 gap-x-4 gap-y-3">
              {categories.map((category) => (
                <li key={category.key}>
                  <Link
                    to={`/category/${category.key}`}
                    className="text-sm text-foreground-300 transition-colors hover:text-primary-400"
                  >
                    {category.name}片
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm uppercase tracking-widest text-foreground-500">
              <a href="#footer-contact" className="hover:text-primary-400">联系我们</a>
            </h4>
            <ul id="footer-contact" className="mt-4 space-y-3 text-sm text-foreground-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-base text-primary-400" />
                <a href={`mailto:${siteInfo.email}`} className="transition-colors hover:text-primary-400">
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-base text-primary-400" />
                <span>{siteInfo.address}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-information-line mt-0.5 text-base text-primary-400" />
                <span>本站内容为演示示例，仅供学习交流使用。</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-200/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {siteInfo.name} · {siteInfo.icp}
          </p>
          <p className="text-xs text-foreground-500">
            本站不提供任何影片播放与下载服务，所有内容均为虚构演示数据。
          </p>
        </div>
      </div>
    </footer>
  );
}